import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';

const LogoLinkContext = createContext();

export const useLogoLink = () => useContext(LogoLinkContext);

export const LogoLinkProvider = ({ children }) => {
    const [logoLink, setLogoLink] = useState('');

    const fetchLogoLink = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/default-setting`, {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            const data = response.data.data.isDefaultSettingsExist;
            setLogoLink(data?.logoLink || '');
        } catch (error) {
            console.error("Failed Fetching Logo Link", error);
        }
    };

    useEffect(() => {
        fetchLogoLink();
    }, []);

    return (
        <LogoLinkContext.Provider value={logoLink}>
            {children}
        </LogoLinkContext.Provider>
    );
};
